module.exports = __webpack_public_path__ + "img/sphere08-graph-black.c74a26a8.png";